import { IonIcon } from '@ionic/react'
import { useStoreMap } from 'effector-react'
import { chevronForward } from 'ionicons/icons'
import { balanceModel } from '~/entities/Balance'
import { Button, IconButton } from '~/shared/ui/Buttons'
import { PayCardContent, PayCardWrapper } from '~/shared/ui/PayCard'
import { myPalette } from '~/shared/ui/theme'

export function SelectedPayCard() {
  const selectedPayCard = useStoreMap(
    balanceModel.$selectedPayCard,
    (payCard) => payCard?.getAttributes(),
  )

  return (
    <Button
      to='/bank-cards'
      variant='textLink'
      style={{ marginBottom: '32px', display: 'block' }}
      contentProps={{ style: { padding: 0 } }}
    >
      {selectedPayCard && (
        <PayCardWrapper>
          <PayCardContent cardNumber={selectedPayCard?.maskedNumber} />
          <IconButton
            style={{ padding: 0, color: myPalette.midnightBlue.main }}
            icon={chevronForward}
          />
        </PayCardWrapper>
      )}

      {!selectedPayCard && (
        <Button
          fullWidth
          variant='lightSteelBlueBorder'
          size='large'
          endDecorator={
            <IonIcon
              icon={chevronForward}
              color={myPalette.midnightBlue.main}
              style={{ width: '24px', height: '24px' }}
            />
          }
          contentProps={{ style: { justifyContent: 'space-between' } }}
        >
          Выбрать карту
        </Button>
      )}
    </Button>
  )
}
